// import {format} from 'date-fns'

class Audit {
  constructor(data) {
    this.pk = data.pk;
    this.updatedBy = [data.actor.first_name, data.actor.last_name].filter(Boolean).join(' ');
    this.new_data = data.target_data;
    this.old_data = data.target_old_data;
    this.date = data.created_at;
    this.name = data.target_data.name;
    this.profileImage = data.actor.profile_image;
  }
}
export default Audit;